module.exports = __webpack_public_path__ + "img/mountain-sidebar.aa34017d.png";